import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
    this.awsS3Api = options.awsS3Api
  }

  async getUserProfile () {
    const { data } = await this.kulapApi.getUserProfile()
    this.store.dispatch('setUser', data)
    return data
  }

  async getKycFormData () {
    const { data } = await this.kulapApi.getKycFormData()
    return data
  }

  async getKycVerification () {
    const { data } = await this.kulapApi.getKycVerification()
    return data
  }

  async submitKyc (formData) {
    const form = Object.assign({}, formData)
    const { data } = await this.kulapApi.patchSubmitKycForm(form)
    return data
  }

  async postUploadKycDocs (file, name) {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('file', file)
    const { data } = await this.kulapApi.postUploadKycDocs(formData)
    return data
  }

  async getKulapUtilityFile () {
    const [ countries, provincesInThailand, occupationList, businessList, averageIncomeList, kycTopicsList ] = await Promise.all([
      this.awsS3Api.getCountries(),
      this.awsS3Api.getProvincesInThailand(),
      this.awsS3Api.getOccupationList(),
      this.awsS3Api.getBusinessList(),
      this.awsS3Api.getAverageIncomeList(),
      this.awsS3Api.getKycTopicsList()
    ])
    return {
      countries: countries.data,
      provincesInThailand: provincesInThailand.data,
      occupationList: occupationList.data,
      businessList: businessList.data,
      averageIncomeList: averageIncomeList.data,
      kycTopicsList: kycTopicsList.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/SummaryOfKYC/service.js